module.exports = __webpack_public_path__ + "static/media/aidemi.6fe991b3.png";